import NoData from 'global/components/alerts/NoData';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { useContext, useMemo } from 'react';
import { _standingsTypes } from './LeagueStandings';
import { SectionStandingz } from './SectionStandingz';
import { MiniSwiper } from 'global/components/swipers/MiniSwiper';
import { _matchLsTypes } from 'projectSpecific/sports/cnr/reducers/SportsDataReducer';

const LevelSectionStandings = ({
  _matchKey_page,
  _standingType,
  _teamKey_page,
  _teamsFavs,
  forOverview,
  forPlayoff,
  noData,
  playoffLevel,
  selectedLevelKey,
  showPlayoffPicture,
}) => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { sportsShowType, matches_info, } = sportsSeason_state ?? {};
  const { matches_groupInfo } = matches_info ?? {}
  const { levelKeys } = matches_groupInfo ?? {}

  const { _levelKeys, _matchSections } = useMemo(() => {
    const _levelKeyz = _.difference(levelKeys, [_matchLsTypes.Non, _matchLsTypes.nonDistrict, _matchLsTypes.nonSection])
    if (!_matchKey_page) { return { _levelKeys: _levelKeyz, _matchSections: null } }
    const { matches } = matches_info ?? {}
    const _match = matches?.[_matchKey_page]
    const { away, home } = _match ?? {}
    const { levels: levels_away, sections: sections_away } = away ?? {}
    const { levels: levels_home, sections: sections_home } = home ?? {}
    const _matchLevelKeys = [levels_away]
    const _matchSections = [`${levels_away}-${sections_away}`]
    if (levels_home !== levels_away && !_.includes(_matchLevelKeys, levels_home)) { _matchLevelKeys.push(levels_home) }
    if (sections_home !== sections_away) { _matchSections.push(`${levels_home}-${sections_home}`) }
    return { _levelKeys: _.sortBy(_matchLevelKeys).reverse() }
  }, [levelKeys, _matchKey_page])

  const levelSectionsContent = (lks, matchSections) => {
    if (!lks) return null;
    return _.map(lks, lk => ({
      caption: lk,
      content: <SectionStandingz levelKey={lk} matchSections={matchSections} _teamsFavs={_teamsFavs} teamKey={_teamKey_page} matchKey={_matchKey_page} />
    }));
  };

  const leagueStandings = useMemo(() => {

    if (!_levelKeys) { return; }

    if (showPlayoffPicture || playoffLevel) {
      return <SectionStandingz levelKey={playoffLevel} _teamsFavs={_teamsFavs} />
    }

    if (_teamKey_page) {
      return <SectionStandingz levelKey={selectedLevelKey} _teamsFavs={_teamsFavs} teamKey={_teamKey_page} matchKey={_matchKey_page} forOverview={forOverview} />
    }

    if (_matchKey_page) {
      return <MiniSwiper
        includeButtons={true}
        swipeItems={levelSectionsContent(_levelKeys, _matchSections)}
        showButtons={false}
      />
    }
    if (noData) {
      return <NoData fullCaption={'No Standings'} />;
    }

    return (
      <MiniSwiper
        includeButtons={true}
        swipeItems={levelSectionsContent(_levelKeys)}
        showButtons={true}
      />
    );
  }, [
    sportsShowType,
    _standingType,
    forOverview,
    playoffLevel,
    showPlayoffPicture,
    selectedLevelKey,
    _matchKey_page,
    _levelKeys
  ]);

  return leagueStandings;
};

export default LevelSectionStandings;
